<template>
  <v-app>
    <v-main>
      <v-container class="text-center pa-8">
        <h2>Hubo un error al cargar el portal</h2>
        <p>Inténtalo de nuevo</p>

        <v-btn color="primary" @click="reload">
          Reintentar
        </v-btn>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  methods: {
    reload () {
      window.location.reload()
    }
  }
}
</script>
